/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["iframe[_ngcontent-%COMP%]{width:100%;height:100%;border:unset;display:block}"];
export { styles as styles };



// WEBPACK FOOTER //
// ./src/app/core/achoo-iframe/achoo-iframe.component.scss.shim.ngstyle.js.pre-build-optimizer.js